export default () => ({
  show: false,
  loading: true,
  onCancel: false,
  fullPage: true,
  guest: {
    name: null
  },
  person: {
    name: null,
    dweller_guest_list_id: null
  },
  guests: [],
  persons: [],
  entity: 'guest',
  entities: 'guests',
  prefixRouter: 'dweller.guest'
})



// WEBPACK FOOTER //
// ./src/app/tenant/guest/resources/data.js